"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9510],{

/***/ 49510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ FAQPage_FAQSection; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../node_modules/next/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(75190);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(52261);
;// CONCATENATED MODULE: ./containers/FAQPage/FAQSection/ContentBlock/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-bottom: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  @media only screen and (max-width: 560px) {\n    font-size: 15px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n\n  @media only screen and (max-width: 560px) {\n    font-size: 15px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cb727312-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacings.spacing_xxl;
});
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cb727312-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.textStyles.title2;
});
var Contents = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cb727312-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.textStyles.content2;
});

;// CONCATENATED MODULE: ./containers/FAQPage/FAQSection/ContentBlock/index.js




var ContentBlock = function(param) {
    var title = param.title, contents = param.contents;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Contents, {
                dangerouslySetInnerHTML: {
                    __html: contents
                }
            })
        ]
    });
};
ContentBlock.propTypes = {
    title: (prop_types_default()).string,
    contents: (prop_types_default()).string
};
/* harmony default export */ var FAQSection_ContentBlock = (ContentBlock);

// EXTERNAL MODULE: ../../node_modules/antd/es/collapse/index.js + 8 modules
var collapse = __webpack_require__(30676);
;// CONCATENATED MODULE: ./containers/FAQPage/FAQSection/FAQCollapse/styled.js

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-width: 1px;\n  border-bottom: 0;\n  border-left: 0;\n  border-right: 0;\n  border-color: ",
        ";\n  border-radius: 0;\n  background-color: ",
        ";\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n\n  &.ant-collapse-item {\n    .ant-collapse-header {\n      color: ",
        ";\n    }\n  }\n\n  &.ant-collapse-item-active {\n    .ant-collapse-header {\n      color: ",
        ";\n    }\n  }\n\n  & {\n    .ant-collapse-header {\n      padding: 0px !important;\n      height: 60px;\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      ",
        ";\n      font-size: 22px;\n      @media only screen and (max-width: 560px) {\n        font-size: 20px;\n      }\n    }\n    .ant-collapse-content {\n      background-color: ",
        ";\n      padding-top: ",
        ";\n      padding-left: ",
        ";\n      padding-right: 100px;\n\n      .ant-collapse-content-box {\n        padding: 0px;\n      }\n\n      @media only screen and (max-width: 560px) {\n        padding-top: 16px;\n        padding-left: 16;\n        padding-right: 0;\n      }\n    }\n  }\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-right: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Panel = collapse/* default.Panel */.Z.Panel;
var styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f73efb06-0"
})(styled_templateObject());
var CustomCollapse = (0,styled_components_browser_esm/* default */.ZP)(collapse/* default */.Z).withConfig({
    componentId: "sc-f73efb06-1"
})(styled_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.lightGray;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var CustomCollapsePanel = (0,styled_components_browser_esm/* default */.ZP)(Panel).withConfig({
    componentId: "sc-f73efb06-2"
})(styled_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.lightGray;
}, function(param) {
    var theme = param.theme;
    return theme.colors.blackGreen;
}, function(param) {
    var theme = param.theme;
    return theme.colors.prune;
}, function(param) {
    var theme = param.theme;
    return theme.textStyles.title1;
}, function(param) {
    var theme = param.theme;
    return theme.colors.lightGray1;
}, function(param) {
    var theme = param.theme;
    return theme.spacings.spacing_xxl;
}, function(param) {
    var theme = param.theme;
    return theme.spacings.spacing_xxl;
});
var IconWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f73efb06-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.spacings.spacing_m;
});

;// CONCATENATED MODULE: ./containers/FAQPage/_faqs.js
var faqData = [
    {
        id: 1,
        title: "DESIGN & INSTALLATION",
        content: [
            {
                id: 1,
                title: "I would love to see what Classy Closets can do for me. How do I get started?",
                contents: "To start quickly, fill out any contact form on our website, and someone our office will get back to you. You can also call us at 801-572-7712 or visit our Midvale showroom."
            },
            {
                id: 2,
                title: "How much experience do your designers have?",
                contents: "Classy Closets designers have an average of 13 years of industry experience – 4 times the national average. All of our designers are trained extensively in closet and space design to help you better visualize your project and eliminate any confusion or misunderstandings. To learn more about our designers, visit your city Classy Closets Location Page."
            },
            {
                id: 3,
                title: "What happens when my project is ready to be installed?",
                contents: "We commit to a specific installation date(s) and have a 95 % on-time delivery record. Installation dates are confirmed via email, text, or phone about five days before your installation."
            },
            {
                id: 4,
                title: "Do you use sub-contractors for installation?",
                contents: "No. All Classy Closets installers are employees of the company and we have decades of experience within our installation team.  Each job is led by an installer that has successfully completed our training program to qualify them for the installation he/she is performing."
            }, 
        ]
    },
    {
        id: 1,
        title: "COMPANY GENERAL",
        content: [
            {
                id: 1,
                title: "Who owns each Classy Closets location?",
                contents: "Each Classy Closets location is individually owned and operated. We are not burdened with expensive franchise fees. We are also not locked into materials and styles determined by corporate franchises or national re-sellers. Our customers benefit from our flexibility and ability to quickly respond to the latest trends in style. The Corporate office for Classy Closets USA is located in Chandler, Arizona."
            },
            {
                id: 2,
                title: "Why should I go with Classy Closets?",
                contents: "There are many reasons why Classy Closets is a great company to work with, including: \n          <ul class='list'> \n            <li>Classy Closets originated in Arizona in 1983. We are locally owned, operated, and we rely solely on our in-house professional employees for all your design, manufacturing, and installation needs. We are also licensed, bonded, and insured.</li>\n            <li>We have our production facilities using state-of-the-art computerized equipment (saws, drills, and edgebanders).</li>\n            <li>We offer two installation methods. We install our closets using either a wall-mounted system or a floor-based system.</li>\n            <li>Our products are truly customized: While other companies may assemble modular units together to fit within the customer’s space, we truly build wall to wall. We are equipped to make final cuts on-site to ensure a solid fit, and we also provide custom widths, heights, and depths.</li>\n            <li>We provide a greater selection of materials:</li>\n                <ul>\n                <li>Material options: solid wood, plywood, high-pressure laminate, thermofused melamine.</li>\n                <li>Finishes: Custom stain, paint, laminate, thermofused melamine, as well as textured melamine.</li>\n                <li>Design options: both floor-based and off-floor units</li>\n                <li>Door Styles: Wood raised panel, wood flat or slab, thermofoil raised panel, and flat laminate panel</li>\n                <li>Drawer box options: Wood dovetail and melamine box options come in all sizes and shapes specifically designed for you</li>\n                <li>Drawer slide options: Soft-close full-extension, ball-bearing full-extension, roller full-extension, or  \xbe extension</li>\n                <li>Color and stain: In-house wood stain to match any color, over 200 high-pressure laminate colors, and over 100 thermofused melamine wood grains and colors as well as the modern “textured melamine.”</li>\n                <li>Hardware: European concealed hinges, and hundreds of handle and knob options</li>\n                <li>Hanging rods: Steel chrome plated, oil-rubbed bronze, satin nickel, and more</li>\n                </ul>\n            <li>We offer a limited lifetime guarantee.</li>\n          </ul>\n          "
            }, 
        ]
    },
    {
        id: 1,
        title: "COST",
        content: [
            {
                id: 1,
                title: "Can you let me know how much my project will cost?",
                contents: "Every project is unique and based on the specific space and needs of our customers. While it is difficult to provide realistic price estimates over the phone, we can give you a good price expectation after a short in-home consultation; We may also be able to give you a price estimate, depending on the complexity of the project if you visit one of our showrooms. Our designers are most qualified to answer these questions. If you call in advance of your visit, we will make every attempt to have a designer available to meet with you."
            },
            {
                id: 4,
                title: "Do you manufacture your products?",
                contents: "Yes, Classy Closets is a direct manufacturer and has full control of the quality of our product from start to finish. Unlike many others in our industry, we do not source pre-fabricated parts from large producers thousands of miles away. By controlling our manufacturing, we also have great flexibility in design and can react quickly should any adjustments be needed."
            },
            {
                id: 5,
                title: "Do you use particleboard or pressboard?",
                contents: "Yes, we offer over 40 beautiful real wood finishes as well as providing our customers with the opportunity for a custom stain or paint finish."
            },
            {
                id: 6,
                title: "Do you have real wood options?",
                contents: "The material substrate we use (pressboard, MDF, or plywood) is determined by the type of laminate or veneer that is being adhered to it. Melamine, the primary laminate used for closets and furniture, requires a very smooth and stable surface which makes particleboard the best substrate for this material. Pressboard is available in various grades based on density. We use only the highest quality industrial grade pressboard compared to the standard commercial grade used by most others. Wood veneers are either adhered to plywood or MDF (medium-density fiberboard) substrate. We use a top-quality calibrated core plywood substrate for our standard wood veneers."
            },
            {
                id: 7,
                title: "What is wood veneer? When is veneer used vs. solid wood?",
                contents: "Veneer refers to thin slices of wood that are glued to a substrate core to produce flat panels with a consistent grain pattern. Planks of solid wood wide enough for cabinet cases are not available in most hardwood species and also tend to warp and curl over time. Veneers are used for flat panel surfaces such as cabinet cases and closets. Solid woods are used for decorative fronts such as raised panel and shaker styles as well as moldings."
            },
            {
                id: 8,
                title: "Do your products fade or darken over time?",
                contents: "Some materials will change color with aging while others will remain consistent. Laminates such as melamine will never change in color even when exposed to sunlight. Real woods will age over time and typically become darker. Wood is a natural product and the species and finish could affect the degree of aging."
            }, 
        ]
    },
    {
        id: 1,
        title: "PRODUCT MAINTENANCE",
        content: [
            {
                id: 1,
                title: "How do I adjust a shelf?",
                contents: "Shelves can be easily adjusted. Follow the instructions below for the type of shelf you are moving. Adjustable shelving on pins: For closets, garage cabinets and furniture shelves behind doors simply remove the shelf by lifting one end about 2 inches. Then pull the shelf out, remove all four shelf pins and re-insert them at the desired height. Replace the shelf. (pliers may help in removing shelf pins)Fixed shelving: Unlock the Knock Down (KD) fittings with a Phillips screwdriver from the bottom or underneath. Then, lightly tap underneath the shelf until it comes free of the fasteners and then pull the shelf out."
            },
            {
                id: 2,
                title: "How do I clean my system?",
                contents: "Melamine and high-pressure laminate systems clean easily with a damp cloth and some glass cleaner or 409. To remove tough spots such as glue or ink use a small amount of mineral spirits or Goo Gone. Do not use an abrasive cleaner on laminate products. Endust is a great cleaner for wood products. For more information go to our care instructions."
            }, 
        ]
    },
    {
        id: 1,
        title: "ENVIRONMENTAL AWARENESS",
        content: [
            {
                id: 1,
                title: "Do you consider yourself an environmentally conscious company?",
                contents: "Yes, we do. Classy Closets uses over 95% pre-consumer recycled materials in its products. Our Green Line is a 100% “green” product that is harvested from sustainable forests and qualifies for LEED. Our Green Building Division is headed by an employee who is a LEED Accredited Professional."
            }, 
        ]
    },
    {
        id: 1,
        title: "SERVICE & WARRANTY",
        content: [
            {
                id: 1,
                title: "What if I need a repair or service in the future?",
                contents: "Just contact us, and we are happy to help. Our customer service department can be reached via our online contact request form found on our website. Both phone calls and online submittals are promptly responded to."
            },
            {
                id: 2,
                title: "What is your warranty?",
                contents: "We are fully committed to the quality of both our product and installation and offer a lifetime limited warranty on our materials and workmanship as long as you live in the home."
            }, 
        ]
    }, 
];

;// CONCATENATED MODULE: ./containers/FAQPage/FAQSection/FAQCollapse/index.js






var FAQCollapse = function() {
    var ExpandIconPlus = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrap, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                alt: "collapse icon plus",
                src: "/icons/collapse_plus.png",
                width: 17,
                height: 17,
                loading: "lazy",
                quality: 100
            })
        });
    };
    var ExpandIconClose = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrap, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                alt: "collapse icon close",
                src: "/icons/collapse_close_purple.png",
                width: 17,
                height: 17,
                loading: "lazy",
                quality: 100
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCollapse, {
            // defaultActiveKey={["0"]}
            expandIconPosition: "left",
            expandIcon: function(param) {
                var isActive = param.isActive;
                return isActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandIconClose, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandIconPlus, {});
            },
            accordion: true,
            children: faqData.map(function(faq, key) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomCollapsePanel, {
                    header: faq.title,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: faq.content.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection_ContentBlock, {
                                title: item.title,
                                contents: item.contents
                            }, index);
                        })
                    })
                }, key);
            })
        })
    });
};
/* harmony default export */ var FAQSection_FAQCollapse = (FAQCollapse);

;// CONCATENATED MODULE: ./containers/FAQPage/FAQSection/styled.js

function FAQSection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 35px;\n  padding-bottom: 60px;\n  padding-left: ",
        "px;\n  padding-right: ",
        "px;\n\n  @media only screen and (max-width: 768px) {\n    padding-left: ",
        "px;\n    padding-right: ",
        "px;\n  }\n  @media only screen and (max-width: 560px) {\n    padding-top: 16px;\n    padding-bottom: 41px;\n    padding-left: ",
        "px;\n    padding-right: ",
        "px;\n  }\n"
    ]);
    FAQSection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FAQSection_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  padding-bottom: 25px;\n  margin-bottom: 0;\n  @media only screen and (max-width: 560px) {\n    font-size: 30px;\n    padding-bottom: 16px;\n  }\n"
    ]);
    FAQSection_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FAQSection_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  \n"
    ]);
    FAQSection_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var FAQSection_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1861578d-0"
})(FAQSection_styled_templateObject(), function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.desktop;
}, function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.desktop;
}, function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.ipad;
}, function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.ipad;
}, function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.layout.content.paddingHorizontal.mobile;
});
var styled_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-1861578d-1"
})(FAQSection_styled_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.textStyles.sectionTitle;
});
var FAQsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1861578d-2"
})(FAQSection_styled_templateObject2());

;// CONCATENATED MODULE: ./containers/FAQPage/FAQSection/index.js




var FAQSection = function() {
    var footerBgColor = "#D6D5D515";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FAQSection_styled_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Title, {
                children: "Frequently Asked Questions"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQsContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection_FAQCollapse, {})
            })
        ]
    });
};
/* harmony default export */ var FAQPage_FAQSection = (FAQSection);


/***/ })

}]);